import {RootObject} from "../model/slicemodel/RootObject";

export default class Utils {
	static convertNasapiObjectTypesToArrays(data: RootObject) {
		this.convertModelSliceToArray(data);
		this.convertFinanceOfferToArray(data);
		this.convertEveryAprTermToArray(data);
		return data;
	}

	static convertModelSliceToArray(data: RootObject) {
		if (!Array.isArray(data.Response.Model.ModelSlices.ModelSlice)) {
			data.Response.Model.ModelSlices.ModelSlice = [data.Response.Model.ModelSlices.ModelSlice]
		}
	}
	static convertFinanceOfferToArray(data: RootObject) {
		data.Response.Model.ModelSlices.ModelSlice.forEach((modelSlice: any) => {
			if (modelSlice.PaymentEstimator?.FinanceOffers?.FinanceOffer &&
					!Array.isArray(modelSlice.PaymentEstimator.FinanceOffers.FinanceOffer)) {
				modelSlice.PaymentEstimator.FinanceOffers.FinanceOffer = [modelSlice.PaymentEstimator.FinanceOffers.FinanceOffer];
			}
		});
	}
	static convertEveryAprTermToArray(data: any) {
		data.Response.Model.ModelSlices.ModelSlice.forEach((modelSlice: any) => {
			if (modelSlice.PaymentEstimator?.FinanceOffers?.FinanceOffer) {
				modelSlice.PaymentEstimator.FinanceOffers.FinanceOffer.forEach((offer: any) => {
					if (!Array.isArray(offer.APRTerms.APRTerm)) {
						offer.APRTerms.APRTerm = [offer.APRTerms.APRTerm];
					}
				});
			}
		});
	}
}
